import { buttonConfig } from './button';
import { brandColors } from './colors';
import { fieldConfig } from './field';
import { brandFont } from './font';
import { teaserConfig } from './teaser';

import type { PopupConfig } from '@onetext/api';

export const defaultBrandConfig : PopupConfig = {
    style: {
        color: brandColors,
        font:  brandFont
    },
    brandSDKName: 'raycon',
    component:    {
        button: buttonConfig,
        field:  fieldConfig,
        teaser: teaserConfig
    }
};
